import { render, staticRenderFns } from "./PriceListFilter.vue?vue&type=template&id=7f978be4&"
import script from "./PriceListFilter.vue?vue&type=script&lang=ts&"
export * from "./PriceListFilter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports